export default "__VITE_ASSET__Chi0_nGW__"